// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ywikqrzmmcccgeomjwcn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl3aWtxcnptbWNjY2dlb21qd2NuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIzMzA3MDIsImV4cCI6MjA2NzkwNjcwMn0.5ZibKpns-Hksjz-N4iMczs53rMVb6AtJk1yLQraFyBE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});